var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.btn_class,attrs:{"to":{ name: _vm.to_name},"text":"","block":"","color":_vm.color}},[_c('v-icon',[_vm._v(_vm._s(_vm.svgPathComputed))]),_vm._v(" "+_vm._s(_vm.submenuComputed))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }